"use client";

import Image from "next/image";

import { CardHeader, CardTitle } from "@/shared/components/common/Card";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import staticData from "@/public/data/hotel/detail.json";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";

interface SidebarcardHeaderProps {
  headerData: {
    img: string;
    title: string;
    description?: string;
    stars?: string;
  };
}

export default function SidebarcardHeader({
  headerData: { img, stars, title, description },
}: SidebarcardHeaderProps) {
  return (
    <CardHeader className="!p-0 hidden md:block">
      <Flex className="gap-4 items-center">
        <Image
          src={img}
          alt="hotel-image"
          width={2000}
          height={2000}
          className="w-16 h-16 rounded-sm"
        />
        <Flex className="flex-col gap-y-3">
          <Flex className="gap-2 items-center">
            <CardTitle>{title}</CardTitle>
            {stars && (
              <Flex className="items-center">
                (
                <PhosphorIcon
                  name="Star"
                  size={14}
                  weight="fill"
                  className="text-amber ml-2"
                />
                <Typography variant="caption">
                  {stars}
                  {staticData.sidebarCard.header.starLabel})
                </Typography>
              </Flex>
            )}
          </Flex>
          {description && (
            <Typography
              variant="body2"
              className="text-sm text-muted-foreground"
            >
              {description}
            </Typography>
          )}
        </Flex>
      </Flex>
    </CardHeader>
  );
}
